import { formatCurrency } from '@/common/utils/formatters'
import { Cluster } from '../../types/cluster'

interface SingleMarkerOptions {
  cluster?: Cluster
  showPrice?: boolean
  colorScheme?: 'dark' | 'light'
}

export const singleMarker = ({ cluster, showPrice, colorScheme }: SingleMarkerOptions) => {
  const markerFill = colorScheme === 'dark' ? '#EAEAEA' : '#121212'
  const innerCircleFill = colorScheme === 'dark' ? '#003460' : '#B0D6F7'
  const iconFill = colorScheme === 'dark' ? '#8AC2F3' : '#0070D0'

  const productPrice = formatCurrency(Number(cluster?.product_price_value || 0))

  const rectPriceForOne = `
      <rect x="24" y="9" rx="16" ry="16" width="${productPrice.length * 8.3 + 24}" height="32" fill="#282828" />
      <text x="52" y="29" text-anchor="left" font-size="12" fill="#8AC2F3" font-family="'Merriweather Sans', sans-serif">${productPrice}</text>
    `

  const svg = `
    <svg width="${showPrice ? 240 : 44}" height="45" viewBox="0 0 38 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      ${showPrice ? rectPriceForOne : ''}
      <g filter="url(#filter0_f_21373_44365)">
        <ellipse cx="26" cy="53.5" rx="7" ry="2.5" fill="black" fill-opacity="0.2" />
      </g>
      <g filter="url(#filter1_d_21373_44365)">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M26 4C37.598 4 47 13.402 47 25C47 33.8926 41.4727 41.4942 33.6663 44.5567L27.1961 53.4007C27.0612 53.5858 26.8821 53.7369 26.6739 53.8412C26.4657 53.9455 26.2346 54 26 54C25.7654 54 25.5343 53.9455 25.3261 53.8412C25.1179 53.7369 24.9388 53.5858 24.8039 53.4007L18.3337 44.5567C10.5273 41.4941 5 33.8926 5 25C5 13.402 14.402 4 26 4Z"
          fill="${markerFill}" />
      </g>
      <path
        d="M43 25C43 15.6112 35.3888 8 26 8C16.6112 8 9 15.6112 9 25C9 34.3888 16.6112 42 26 42C35.3888 42 43 34.3888 43 25Z"
        fill="${innerCircleFill}" />
      <path
        d="M18.5 33.3327H28.5M19.3333 22.4993H27.6667M27.6667 33.3327V18.3327C27.6667 17.8907 27.4911 17.4667 27.1785 17.1542C26.866 16.8416 26.442 16.666 26 16.666H21C20.558 16.666 20.134 16.8416 19.8215 17.1542C19.5089 17.4667 19.3333 17.8907 19.3333 18.3327V33.3327M27.6667 25.8327H29.3333C29.7754 25.8327 30.1993 26.0083 30.5118 26.3208C30.8244 26.6334 31 27.0573 31 27.4993V29.166C31 29.608 31.1756 30.032 31.4882 30.3445C31.8007 30.6571 32.2246 30.8327 32.6667 30.8327C33.1087 30.8327 33.5326 30.6571 33.8452 30.3445C34.1577 30.032 34.3333 29.608 34.3333 29.166V23.191C34.3335 22.9711 34.2902 22.7533 34.2058 22.5502C34.1214 22.3471 33.9976 22.1627 33.8417 22.0077L31 19.166"
        stroke="${iconFill}" stroke-width="0.833333" stroke-linecap="round" stroke-linejoin="round" />
      <defs>
        <style type="text/css">
          <![CDATA[
            @import url('https://fonts.googleapis.com/css2?family=Merriweather+Sans:ital,wght@0,300..800;1,300..800&display=swap');
          ]]>
        </style>
        <filter id="filter0_f_21373_44365" x="17" y="49" width="18" height="9" filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur_21373_44365" />
        </filter>
        <filter id="filter1_d_21373_44365" x="0" y="0" width="52" height="60" filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_21373_44365" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_21373_44365" result="shape" />
        </filter>
      </defs>
    </svg>
  `

  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`
}
